var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-box",style:({ width: `${_vm.width}px`, height: `${_vm.height}px`, marginLeft: _vm.marginLeft })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }